module.exports = __webpack_public_path__ + "static/media/currency.83713766.svg";